// Module
var code = "<react-component name=\"StyleMembersList\"></react-component>\n";
// Exports
module.exports = code;